import { ButtonClean, useModalContext } from '@fourthwall/components';
import React from 'react';
import { isPaidTier } from '../../../../utils';
import { useTierContext } from '../../hooks/useTierContext';
import { CurrenciesUpdateModal } from '../CurrenciesUpdateModal';
export const UpdateCurrencyConversion = () => {
    const modal = useModalContext();
    const { tier, form, enabledCurrencies, isPriceRatesLoading, updateCurrencyConversion } = useTierContext();
    if (!tier)
        return null;
    if (!isPaidTier(tier))
        return null;
    if (!enabledCurrencies)
        return null;
    return (React.createElement(ButtonClean, { label: "Update currency conversion", withUnderline: true, appearance: "secondary", disabled: tier.statistics.membersCount > 0 || isPriceRatesLoading, onClick: () => {
            modal.open(CurrenciesUpdateModal, {
                price: form.values.price,
                enabledCurrencies,
                tier,
                onSave: updateCurrencyConversion,
            });
        } }));
};
